import store from "../../store";
import api from "../../utils/interface";
import {
  setFormData,
  setProfileFieldsJSON,
  setProfileLayoutJSON,
} from "../../store/slices/profile/profileSlice";
import { toast } from "react-toastify";

export const getFormRenderer = async (parentId, organizationId) => {
  const fd = new FormData();

  fd.append("mappedEntityType", "PRF");
  fd.append("parentType", "AGRP");
  fd.append("parentId", parentId);
  fd.append("organizationId", organizationId);

  try {
    api.post(`/agsp/getViewMasterData`, fd).then((response) => {
      if (response && response.status === 200) {
        store.dispatch(setFormData(response.data));
        const profileLayoutJSON =
          typeof response.data.publishedformlayout === "string"
            ? JSON.parse(response.data.publishedformlayout)
            : response.data.publishedformlayout;

        const profileFieldsJSON =
          typeof response.data.publishedformfields === "string"
            ? JSON.parse(response.data.publishedformfields)
            : response.data.publishedformfields;

        store.dispatch(setProfileFieldsJSON(profileFieldsJSON));
        store.dispatch(setProfileLayoutJSON(profileLayoutJSON));
      }
    });
  } catch (error) {
    console.error("Error fetching data", error);
  }
};

export const updateFromRenderer = async (entity, entityid, entitytype) => {
  const excludedKeys = [
    "entitytype",
    "ag_name",
    "entityid",
    "parenttype",
    "parentid",
    "organizationid",
    "enterpriseid",
    "code",
    "created_date",
    "modified_date",
    "role_id",
    "user_id",
    "default_member_id",
    "is_first_login",
    "status",
    "created_by",
    "seq_no",
    "modified_by",
    "role",
    "profile_id",
    "emp_code",
    "legacy_customer_id",
    "legacy_customer_id_json",
    "owner_id",
    "client_id",
    "membership_number",
    "profile_json",
    "rm_id",
    "rm_mobile",
    "rm_name",
    "rm_email",
    "password",
    "confirm_password",
    "profile_data",
    "renewal_pending",
    "ag_id",
    "qualification",
    "last_name",
    "first_name",
  ];

  // Filter the entity to remove unwanted fields
  const filteredEntity = Object.keys(entity).reduce((acc, key) => {
    if (!excludedKeys.includes(key)) {
      acc[key] = entity[key];
    }
    return acc;
  }, {});
  const fd = new FormData();
  const formattedEntity = {
    profile_json: JSON.stringify(filteredEntity),
  };
  fd.append("entity", JSON.stringify(formattedEntity));
  fd.append("entityid", entityid);
  fd.append("entitytype", entitytype);

  try {
    const response = await api.post(`/entity/update`, fd);
    if (response.status === 200) {
      toast.success("Profile updated successfully");
      return true; // Return true if the status is 200
    }
    return false; // Return false for other statuses
  } catch (error) {
    toast.error(error.response?.data?.error_message || "An error occurred");
    return false; // Return false on error
  }
};

export const getAllDropdownListItems = async (
  type,
  profileFieldsJSON,
  parentType,
  parentId,
  ownerType,
  ownerValue
) => {
  const fd = new FormData();

  fd.append("type", type);
  fd.append("parentType", parentType);
  fd.append("parentId", parentId);

  if (type === "CTY") {
    fd.append("ownerType", ownerType);
    fd.append("ownerValue", ownerValue);
  }

  try {
    const response = await api.post(
      `agsp/customer/getAllDropdownListItems`,
      fd
    );

    if (response.status === 200 && response.data) {
      const data = response.data;

      if (profileFieldsJSON && Object.keys(profileFieldsJSON).length) {
        const updatedProfileFieldsJSON = { ...profileFieldsJSON };
        // Update `data-customvalue` based on `data-datasourcelist`
        Object.keys(updatedProfileFieldsJSON).forEach((key) => {
          const field = updatedProfileFieldsJSON[key];
          if (field["data-datasourcelist"] === type) {
            updatedProfileFieldsJSON[key] = {
              ...field,
              "data-customvalue": data,
            };
          }
        });
        store.dispatch(setProfileFieldsJSON(updatedProfileFieldsJSON));
      } else {
        console.warn(
          "profileFieldsJSON is empty or undefined:",
          profileFieldsJSON
        );
      }
      return data;
    } else {
      console.warn("error", response.data);
    }
  } catch (error) {
    console.error("Error fetching data", error);
  }
};
